import { Component, OnInit } from '@angular/core';
import {UtilService} from "../../services/utilService/util.service";

@Component({
  selector: 'app-super-agents',
  templateUrl: './super-agents.component.html',
  styleUrls: ['./super-agents.component.css']
})
export class SuperAgentComponent implements OnInit {
  breadCrumb: any;

  constructor(private utilService: UtilService) { }

  ngOnInit() {
    this.breadCrumb  = {
      name: 'Super-Agent',
      parent: 'Home',
      subLink: null
    };
    setTimeout(() => {
      this.utilService.initDataTable('vendor-list');
    }, 1000);

  }

}
